/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit SubTitle/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'



/** @type {import('Simple/types.js').View} */
export default function SubTitle({
  children,
  viewPath = "/DesignSystem/SubTitle",
  color,
  fontWeight,
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  text,
  opacity = 1,
  minWidth = "auto",
  textAlign = "left",
  lineHeight = 1,
  whiteSpace
  
}) {
let dtTypographyFontweightSemibold = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.fontWeight.semibold'
        })
  return (<React.Fragment
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 level="h4"
 color={color}
 fontWeight={fontWeight || dtTypographyFontweightSemibold}
 marginTop={marginTop}
 marginBottom={marginBottom}
 marginLeft={marginLeft}
 marginRight={marginRight}
 text={text}
 opacity={opacity}
 minWidth={minWidth}
 textAlign={textAlign}
 lineHeight={lineHeight}
 whiteSpace={whiteSpace}
/>
{children}
</React.Fragment>)
}